import React from "react";
import {VeterinarioObject} from "../../models/Veterinario";
import {prepareFazenda} from "../../models/Fazenda";
import {IonPage, IonContent, IonHeader, IonToolbar, IonButtons,
  IonMenuButton, IonTitle, IonIcon, withIonLifeCycle,
  IonSelect, IonSelectOption, IonChip, IonLabel} from "@ionic/react";
import fb from "../../lib/firebase";
import {EntityList} from "../../components/EntityListNG";
import FormFazenda from "./FormFazenda/FormFazenda";
import {home, star, starOutline, closeCircle} from "ionicons/icons";
import {filtrarFazendas, filtrosFazendaVazios, FazendaFiltros, opcoesEstadoECidade, ordenarFavoritasPrimeiro, temFiltrosAtivos} from "../../lib/utils";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import {fazendaCardContent, fazendaCardSubtitle, fazendaCardTitle} from "./FazendaCard";
import FiltroPill from "../../components/FiltroPill";
import qs from "qs";

interface Props {
  location: any;
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[];
  criterio: string;
  filtros: FazendaFiltros;
}

class Fazendas extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props:Props) {
    super(props);

    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: [],
      criterio: '',
      filtros: filtrosFazendaVazios,
    };

    this.cancelListener = () => {};
  }

  ionViewWillEnter() {
    // set criterio/filtros from query string
    if (this.props.location) {
      const query = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
      const {q} = query;
      if (q === 'mtt') {
        this.setState(
          {criterio: '', filtros: {...this.state.filtros, apenasFavoritas: true}},
          () => this.filtrarColecao('', this.state.filtros),
        );
      } else if (q) {
        const criterio = q.toString();
        this.setState({criterio}, () => this.filtrarColecao(criterio));
      } else if (q === '') {
        this.setState({criterio: ''});
      }
    }
  }

  componentDidMount() {
    this.installListener();
  }
  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    this.setState({loading: true});
    const query = fb.db.collection('fazendas')
      .where('owner', '==', this.props.app.user.uid)
      .orderBy('nome')

    this.cancelListener = query.onSnapshot(snap => {
      // console.log('Fazendas: onSnapshot');
      const colecao = fb.col(snap).filter((f: any) => f.ativo !== false).map(prepareFazenda);
      this.setState({colecao, loading: false});
      this.filtrarColecao(this.state.criterio, this.state.filtros, colecao);
    });
  };

  filtrarColecao = (criterio:string='', filtros?: FazendaFiltros, colecao?: any[]) => {
    if (colecao === undefined)
      colecao = this.state.colecao;
    if (filtros === undefined)
      filtros = this.state.filtros;

    const colecaoFiltrada = ordenarFavoritasPrimeiro(filtrarFazendas(colecao, criterio, filtros));

    this.setState({
      colecaoFiltrada,
      criterio,
      filtros,
    });
  }

  onChangeFiltros = (mudancas: Partial<FazendaFiltros>) => {
    const filtros = {...this.state.filtros, ...mudancas};

    // limpar cidade se ela nao pertencer mais ao estado selecionado
    if (filtros.estado !== this.state.filtros.estado) {
      const {cidades} = opcoesEstadoECidade(this.state.colecao, filtros.estado);
      if (filtros.cidade && !cidades.includes(filtros.cidade))
        filtros.cidade = '';
    }

    this.filtrarColecao(this.state.criterio, filtros);
  };

  onClickInstance = (instance: VeterinarioObject) => {
    this.props.dispatch(actions.jump('/fazendas'));
    this.props.history.push(`/fazendas/${instance.id}/home`);
  };

  renderFiltros() {
    const {filtros} = this.state;
    const {estados, cidades} = opcoesEstadoECidade(this.state.colecao, filtros.estado);

    return (
      <div className="flex flex-nowrap items-center gap-2 overflow-x-auto px-3 py-2">
        <FiltroPill label="Estado">
          <IonSelect
            class="min-w-0"
            interface="popover"
            placeholder="Todos"
            value={filtros.estado}
            onIonChange={e => this.onChangeFiltros({estado: e.detail.value})}
          >
            <IonSelectOption value="">Todos</IonSelectOption>
            {estados.map(estado => (
              <IonSelectOption key={estado} value={estado}>{estado}</IonSelectOption>
            ))}
          </IonSelect>
        </FiltroPill>

        <FiltroPill label="Cidade">
          <IonSelect
            class="min-w-0"
            interface="popover"
            placeholder="Todas"
            value={filtros.cidade}
            onIonChange={e => this.onChangeFiltros({cidade: e.detail.value})}
          >
            <IonSelectOption value="">Todas</IonSelectOption>
            {cidades.map(cidade => (
              <IonSelectOption key={cidade} value={cidade}>{cidade}</IonSelectOption>
            ))}
          </IonSelect>
        </FiltroPill>

        <FiltroPill label="Tipo">
          <IonSelect
            class="min-w-0"
            interface="popover"
            placeholder="Todos"
            multiple={true}
            value={filtros.tipos}
            onIonChange={e => this.onChangeFiltros({tipos: e.detail.value})}
          >
            <IonSelectOption value="Leite">Leite</IonSelectOption>
            <IonSelectOption value="Corte">Corte</IonSelectOption>
          </IonSelect>
        </FiltroPill>

        <IonChip
          class="flex-shrink-0"
          outline={!filtros.apenasFavoritas}
          color={filtros.apenasFavoritas ? 'primary' : undefined}
          onClick={() => this.onChangeFiltros({apenasFavoritas: !filtros.apenasFavoritas})}
        >
          <IonIcon icon={filtros.apenasFavoritas ? star : starOutline}/>
          <IonLabel>Favoritas</IonLabel>
        </IonChip>

        {temFiltrosAtivos(filtros) && (
          <IonChip class="flex-shrink-0" onClick={() => this.onChangeFiltros(filtrosFazendaVazios)}>
            <IonIcon icon={closeCircle}/>
            <IonLabel>Limpar filtros</IonLabel>
          </IonChip>
        )}
      </div>
    );
  }

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>
              Fazendas
            </IonTitle>
            <IonIcon
              icon={home}
              slot="primary"
              class="pr-3 text-2xl"
              onClick={() => this.props.history.push('/home')}
            />
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {this.renderFiltros()}
          <EntityList
            entityLabel="fazenda"
            colecao={this.state.colecaoFiltrada}
            loading={this.state.loading}
            filtrarColecao={this.filtrarColecao}
            addEnabled={true}
            onClickInstance={this.onClickInstance}
            cardSubTitle={fazendaCardSubtitle}
            cardTitle={fazendaCardTitle}
            cardContent={fazendaCardContent}
            ModelForm={FormFazenda}
            criterio={this.state.criterio}
            modalNoPadding={true}
          />
        </IonContent>
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Fazendas));